import { render } from "./AboutDev.vue?vue&type=template&id=b93ea2cc"
import script from "./AboutDev.vue?vue&type=script&lang=js"
export * from "./AboutDev.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\renau\\GitHub\\RPA_Template-RHENRY\\Développement\\NodeJS\\SiteWeb\\website-v2-vuejs3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__